import React from 'react';
import Icon from './Autosave.svg';

export default (props) => <Icon {...props} />;
